/* eslint-disable no-underscore-dangle */
/* eslint-disable react/button-has-type */
/* eslint-disable linebreak-style */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import styled from '@emotion/styled';
import { useParams } from 'react-router';
import _ from 'lodash';
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion';
import Review from './Review';
import WriteReview from './WriteReview';
import WriteReviewLarge from './WriteReviewLarge';
import TotalRatings from './TotalRatings';
import { setReview } from '../../redux/actions/ReviewActions';
import { getAllReviews } from '../../network';

const ProductReviews = ({ auth, setReview, review }) => {
    const customerName = `${auth.first_name} ${auth.last_name}`;
    const customerFirstName = `${auth.first_name}`;
    const userId = auth.customer_id;

    const [allReviews, setAllReviews] = useState([]);
    const [averageRating, setAverageRating] = useState();
    const [totalRecords, setTotalRecords] = useState();
    const [totalPages, setTotalPages] = useState();
    const [filterMenu, setFilterMenu] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [editComment, setComment] = useState('');
    const { id } = useParams();
    // const [postNumber] = useState(3);
    const [newReview, setNewReview] = useState(0);
    const [updatedLike, setUpdateLike] = useState(0);
    const [sort, setSort] = useState({
        sortOrder: 'desc',
        sortBy: 'createdAt'
    });
    const [triggerAnimation, setTransition] = useState({});

    const handleClick = (event) => {
        setFilterMenu(event.currentTarget);
    };

    const handleClose = () => {
        setFilterMenu(null);
    };

    const stripObject = (review) => {
        let fullArray = [];
        let arr = _.flattenDeep(Object.entries(review));
        arr.map((val) => { if (typeof val !== 'string') fullArray.push(val)});
        return fullArray;
    };

    const showAllReviews = (page) => {
        getAllReviews('', 3, page, id, sort.sortOrder, sort.sortBy)
            .then(result => {
                setAllReviews(result.data);
                setAverageRating(result.pageInfo.average.$numberDecimal);
                setTotalRecords(result.pageInfo.totalRecords);
                setTotalPages(result.pageInfo.totalPages);
            })
            .catch(error => console.log(error));
    };

    useEffect(() => {
        showAllReviews(pageNumber);
    }, [totalRecords, newReview, updatedLike, pageNumber, sort, editComment]);

    // const filteredReviews = allReviews.filter((item) => {
    //     return item.product._id === id;
    // });

    const ratings = allReviews.map((item) => {
        return item?.rating?.$numberDecimal;
    });

    const totalProductReviews = totalRecords;

    // const currentPageNumber = (pageNumber * postNumber) - postNumber;

    const handlePrev = () => {
        if (pageNumber > 0) {
            setPageNumber(pageNumber - 1);
        }
    };

    const handleNext = () => {
        if (pageNumber < totalPages) {
            setPageNumber(pageNumber + 1);
        }
    };
    return (
        <ReviewWrapper>
            {
                allReviews.length > 0 ?
                    (
                        <>
                            <ReviewContainer>
                                <CustomerReviews>
                                    <p className="review-title"> Customer Reviews</p>

                                    <TotalRatings average={averageRating} totalReviews={totalRecords} ratings={ratings} />
                                    <WriteReview
                                        id={id}
                                        customer={customerName}
                                        firstName={customerFirstName}
                                        userId={userId}
                                        setNewReview={setNewReview}
                                    />
                                </CustomerReviews>

                                <ReviewList>
                                    <div>
                                        <div className="filter-container">
                                            <p className="filter-text"> Highest Rated </p>
                                            <FilterBtn onClick={handleClick}> Filter </FilterBtn>

                                            <Menu
                                                id="simple-menu"
                                                anchorEl={filterMenu}
                                                keepMounted
                                                open={Boolean(filterMenu)}
                                                onClose={handleClose}
                                            >
                                                <MenuItem> All </MenuItem>
                                                <MenuItem onClick={() => setSort({sortOrder: 'asc', sortBy: 'createdAt'})}> Latest </MenuItem>
                                                <MenuItem onClick={() => setSort({sortOrder: 'asc', sortBy: 'rating'})}> Lowest Ratings </MenuItem>
                                                <MenuItem onClick={() => setSort({sortOrder: 'desc', sortBy: 'rating'})}> Highest Ratings </MenuItem>
                                                <MenuItem> Most Useful </MenuItem>
                                                <MenuItem> 5 Stars </MenuItem>
                                                <MenuItem> 4 Stars </MenuItem>
                                                <MenuItem> 3 Stars </MenuItem>
                                                <MenuItem> 2 Stars </MenuItem>
                                                <MenuItem> 1 Stars </MenuItem>
                                            </Menu>
                                        </div>

                                        {/* <TransitionGroup> */}
                                        {console.log('Review: ', stripObject(review))}
                                        {
                                            allReviews.map((item, index) => (
                                                // <motion.div
                                                //     initial={{ opacity: 0 }}
                                                //     animate={{ opacity: 1, border: '3px solid #733488' }}
                                                //     exit={{ opacity: 0 }}
                                                // >
                                                
                                                <Review
                                                    key={item?._id}
                                                    time={item?.createdAt}
                                                    comment={item.comment}
                                                    customer={`${item?.customer?.first_name} ${item.customer?.last_name}`}
                                                    customerID={item?.customer?._id}
                                                    rating={item?.rating?.$numberDecimal}
                                                    likes={item?.likes}
                                                    reviewID={item?._id}
                                                    userId={userId}
                                                    firstName={customerFirstName}
                                                    setUpdateLike={setUpdateLike}
                                                    setComment={setComment}
                                                    onClick={() => localStorage.setItem('reviewIndex', index)}
                                                    activeLike={localStorage.getItem('reviewIndex') === index.toString()}
                                                    firstItem={index === 0 && localStorage.getItem('comment') === item.comment}
                                                />
                                                // </motion.div>
                                                
                                            ))
                                        }
                                            
                                    </div>
                             

                                    <div className="pagination-container">

                                        <button onClick={handlePrev} className="pagination-btn">
                                            {pageNumber > 1 ?
                                                <img src="/customer-reviews/icon-right.svg" alt="next" style={{ transform: 'rotate(180deg)' }} />
                                                :
                                                <img src="/customer-reviews/icon-left.svg" alt="prev" />
                                            }

                                        </button>
                                        <button onClick={handleNext} className="pagination-btn">
                                            <img src="/customer-reviews/icon-right.svg" alt="next" />
                                        </button>
                                    </div>
                                </ReviewList>

                            </ReviewContainer>
                        </>
                    ) :
                    <WriteReviewLarge
                        id={id}
                        firstName={customerFirstName}
                        userId={userId}
                    />
            }
        </ReviewWrapper >
    );
};

const mapStateToProps = state => ({
    auth: state.auth,
    review: state.review
});


const mapDispatchToProps = {
    setReview
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductReviews);

const ReviewWrapper = styled.div`
    width: 100%;
    padding-left: 0.5rem;
    `;

const ReviewContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 45px;
    width: 90%;
    flex-wrap: wrap;
    padding: 1rem;

    @media only screen and (max-width: 500px){
        width: 90vw;
    }

    @media only screen and (max-width: 1100px){
        justify-content: center;
        padding: 0;
    }
    
    .review-title{
        font-size: 36px;
        line-height: 36px;

        align-items: center;
        color: #000000;
        
        margin-bottom: 1rem;
        padding-left: 0.5rem;
    }
    `;

const CustomerReviews = styled.div`
    display: flex;
    flex-direction: column;
    width: 23rem;

    @media only screen and (max-width: 500px){
        width: 90vw;
    }
`;

const ReviewList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    
    width: fit-content;

    .filter-text{
        font-weight: normal;
        font-size: 20px;
        line-height: 20px;

        display: flex;
        align-items: center;

        color: #000000;
    }

    .filter-container{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 1rem;

        width: 100%;
    }

    .pagination-container{
        display: flex;
        justify-content: space-between;
    }

    .pagination-btn{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px 12px;

        border: 1px solid #D3D9DE;
        border-radius: 24px;
        
        width: 40px;
        height: 32px;
    }
`;

const FilterBtn = styled.button`
    width: 54px;
    height: 24px;

    padding: 6px 12px;

    border: 1px solid #D3D9DE;
    border-radius: 24px;

    font-weight: 500;
    font-size: 12px;
    line-height: 12px;

    color: #353B40;
`;
